import React from 'react';

import Login from '../../login/Login';

export const Main = () => {
  return <Login />;
};
